import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installAuthInterceptors } from "./utils/auth";

// Attach the login token to every API request
installAuthInterceptors();


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <div className='appContainer'>
    <App />
  </div>
);
